<template>
    <div>
        <limitless-page-header title="Frånvarostatistik"></limitless-page-header>

        <div class="content">
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-lg-3">
                            <div class="form-group">
                                <div class="font-weight-semibold mb-2">Gruppera per</div>
                                <div class="custom-control custom-radio mb-2">
                                    <input type="radio" class="custom-control-input" name="group" id="chk-group-none" v-model="filter.group" value="year">
                                    <label class="custom-control-label" for="chk-group-none">År</label>
                                </div>
                                <div class="custom-control custom-radio mb-2">
                                    <input type="radio" class="custom-control-input" name="group" id="chk-group-store" v-model="filter.group" value="store">
                                    <label class="custom-control-label" for="chk-group-store">Butik</label>
                                </div>
                                <div class="custom-control custom-radio">
                                    <input type="radio" class="custom-control-input" name="group" id="chk-group-user" v-model="filter.group" value="user">
                                    <label class="custom-control-label" for="chk-group-user">Anställd</label>
                                </div>
                            </div>
                        </div>
<!--                        <div class="col-lg-3">-->
<!--                            <div class="form-group">-->
<!--                                <div class="font-weight-semibold mb-2">Summera per</div>-->
<!--                                <div class="custom-control custom-radio mb-2">-->
<!--                                    <input type="radio" class="custom-control-input" name="period" id="chk-period-month" v-model="filter.period" value="month" :disabled="filter.group === 'user'">-->
<!--                                    <label class="custom-control-label" for="chk-period-month">Månad</label>-->
<!--                                </div>-->
<!--                                <div class="custom-control custom-radio">-->
<!--                                    <input type="radio" class="custom-control-input" name="period" id="chk-period-year" v-model="filter.period" value="year" :disabled="filter.group === 'user'">-->
<!--                                    <label class="custom-control-label" for="chk-period-year">År</label>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
                        <div class="col-lg-3">
                            <div class="form-group">
                                <div class="font-weight-semibold mb-2">Beräkna på</div>
                                <div class="custom-control custom-radio mb-2">
                                    <input type="radio" class="custom-control-input" name="calc" id="chk-calc-expected" v-model="calc" value="expected">
                                    <label class="custom-control-label" for="chk-calc-expected">Förväntad arbetad tid</label>
                                </div>
                                <div class="custom-control custom-radio">
                                    <input type="radio" class="custom-control-input" name="calc" id="chk-calc-reported" v-model="calc" value="reported">
                                    <label class="custom-control-label" for="chk-calc-reported">Redovisad tid</label>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3">
                            <div class="form-group">
                                <div class="font-weight-semibold mb-2">Exkludera frånvarotyp</div>
                                <v-select
                                    :options="cause_codes"
                                    v-model="excl_causecode"
                                    placeholder="--- Inkludera alla frånvarukoder i frånvaroberäkning ---"
                                    :reduce="opt => opt.id"
                                    multiple
                                ></v-select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-3">
                            <div class="form-group">
                                <v-select
                                    :options="select_years"
                                    v-model="filter.year"
                                    placeholder="-- År --"
                                    :reduce="opt => opt.id"
                                    :clearable="false"
                                ></v-select>
                            </div>
                        </div>
                    </div>
                    <div v-if="filter.group === 'user'" class="row">
                        <div class="col-lg-3">
                            <div class="form-group">
                                <user-filter
                                    v-model="filter.user_id"
                                    :reduce="(opt) => opt.id"
                                    placeholder="-- Anställd --"
                                    :clearable="false"
                                    :filter="filterUsers"
                                ></user-filter>
                            </div>
                        </div>
                    </div>
                    <div v-if="filter.group === 'user'" class="custom-control custom-checkbox mt-3">
                        <input id="debug-workhours" v-model="filter.debug_workhours" type="checkbox" class="custom-control-input">
                        <label for="debug-workhours" class="custom-control-label">Visa beräkning av förväntad tid per dag</label>
                    </div>
                    <div class="row pt-3">
                        <div class="col-lg-3">
                            <limitless-button :busy="busy_loading" @click="getData">Visa</limitless-button>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="data">
                <div
                    v-for="group_id in Object.keys(data)"
                    :key="'g-' + group_id"
                    class="card"
                >
                    <div class="card-header">
                        <h5 class="card-title">{{ data[group_id].label }}</h5>
                    </div>
                    <div class="table-responsive mb-0">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>Period</th>
                                    <th class="text-right">Förväntad tid (t)</th>
                                    <th class="text-right">Förväntad rast (t)</th>
                                    <th class="text-right">Registrerad rast (t)</th>
                                    <th class="text-right">Redovisad tid (t)</th>
                                    <th class="text-right">Arbetad tid (t)</th>
                                    <th v-for="causeCode in cause_codes" :key="'g-' + group_id + '-c-' + causeCode.id" class="text-right">{{ causeCode.id }}</th>
                                    <th class="text-right">Redovisad tid diff</th>
                                    <th class="text-right">Frånvaro %</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(period, p_index) in Object.values(data[group_id].periods)"
                                    :key="'g-' + group_id + '-p-' + p_index"
                                >
                                    <th>{{ period.label }}</th>
                                    <td class="text-right">
                                        {{ formatHours(period.expected_hours) }}
                                        <small v-if="period.holiday_days > 0" class="d-block text-muted">
                                            {{ holidayDeductionLabel(period) }}
                                        </small>
                                        <details v-if="period.workhours_calculation" class="text-left mt-2">
                                            <summary>Visa beräkning</summary>
                                            <div class="mt-2">
                                                Veckotid: {{ formatHours(period.workhours_calculation.workhours_per_week) }} t.<br>
                                                Beräkningsperiod: {{ period.workhours_calculation.from }} – {{ period.workhours_calculation.to }}.<br>
                                                <span v-if="period.workhours_calculation.include_holidays">Helgdagar ingår enligt användarens inställning.</span>
                                                <span v-else>Helgdagar exkluderas.</span>
                                                Vardagar utan schema räknas som 8 timmar.
                                            </div>
                                            <table class="table table-sm mt-2">
                                                <thead>
                                                    <tr>
                                                        <th>Datum</th>
                                                        <th>Underlag</th>
                                                        <th>Tid</th>
                                                        <th class="text-right">Rast (min)</th>
                                                        <th class="text-right">Schematid (t)</th>
                                                        <th class="text-right">Inräknat (t)</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="day in period.workhours_calculation.days" :key="day.date">
                                                        <td>{{ day.date }}</td>
                                                        <td>
                                                            {{ workhoursReason(day) }}
                                                            <span v-if="day.schedule_id"> · Schema #{{ day.schedule_id }}<span v-if="day.schedule_week">, vecka {{ day.schedule_week }}</span></span>
                                                            <span v-if="day.workpercentage !== null"> · {{ day.workpercentage }} %</span>
                                                        </td>
                                                        <td>{{ day.start_of_day || '–' }} – {{ day.end_of_day || '–' }}</td>
                                                        <td class="text-right">{{ day.break }}</td>
                                                        <td class="text-right">{{ day.schedule_hours === null ? '–' : formatHours(day.schedule_hours) }}</td>
                                                        <td class="text-right">{{ formatHours(day.hours) }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </details>
                                    </td>
                                    <td class="text-right">{{ formatMinutesAsHours(period.expected_break) }}</td>
                                    <td class="text-right">{{ formatMinutesAsHours(period.break_minutes) }}</td>
                                    <td class="text-right">{{ formatHours(calcReportedTime(period)) }}</td>
                                    <td class="text-right">{{ formatHours(period.worked_hours) }}</td>
                                    <td v-for="causeCode in cause_codes" :key="'g-' + group_id + '-p-' + p_index + '-c-' + causeCode.id" class="text-right">
                                        {{ formatHours(period[causeCode.id]) }}
                                    </td>
                                    <td class="text-right">{{ calcReportedTimeDiff(period) }}</td>
                                    <td class="text-right">{{ calcAbsensePercent(period) }}</td>
                                </tr>
                            </tbody>
                            <tfoot v-if="data[group_id].summary">
                                <tr>
                                    <th>{{ data[group_id].summary.label }}</th>
                                    <th class="text-right">
                                        {{ formatHours(data[group_id].summary.expected_hours) }}
                                        <small v-if="data[group_id].summary.holiday_days > 0" class="d-block text-muted">
                                            {{ holidayDeductionLabel(data[group_id].summary) }}
                                        </small>
                                    </th>
                                    <th class="text-right">{{ formatMinutesAsHours(data[group_id].summary.expected_break) }}</th>
                                    <th class="text-right">{{ formatMinutesAsHours(data[group_id].summary.break_minutes) }}</th>
                                    <th class="text-right">{{ formatHours(calcReportedTime(data[group_id].summary)) }}</th>
                                    <th class="text-right">{{ formatHours(data[group_id].summary.worked_hours) }}</th>
                                    <th v-for="causeCode in cause_codes" :key="'g-' + group_id + '-summary-c-' + causeCode.id" class="text-right">
                                        {{ formatHours(data[group_id].summary[causeCode.id]) }}
                                    </th>
                                    <th class="text-right">{{ calcReportedTimeDiff(data[group_id].summary) }}</th>
                                    <th class="text-right">{{ calcAbsensePercent(data[group_id].summary) }}</th>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </div> <!-- /content -->
    </div>
</template>

<script>
import apiClient from '@services/ApiClient';
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import vSelect from 'vue-select';
import LimitlessButton from '@components/Limitless/LimitlessButton.vue';
import UserFilter from '@components/Filters/UserFilter.vue';
import BackendRepository from '@services/repositories/BackendRepository';
import { mapState } from 'pinia';
import { useAuthStore } from '@services/pinia/AuthStore';

export default {
    name: 'AbsenseStatistics',
    components: {
        UserFilter,
        LimitlessButton,
        LimitlessPageHeader,
        vSelect,
    },
    data: () => ({
        group: 'month',
        filter: {
            period: 'month',
            group: 'year',
            year: null,
            debug_workhours: false,
        },
        calc: 'expected',
        cause_codes: [],
        excl_causecode: [],
        busy_loading: false,
        data: null,
    }),
    watch: {
        'filter.group': function filterGroup(newVal) {
            if (newVal === 'user') {
                this.filter.period = 'month';
            } else {
                this.filter.user_id = null;
            }
        },
    },
    mounted() {
        BackendRepository.getCauseCodes().then((res) => {
            this.cause_codes = res;
        });
        const date = new Date();
        this.filter.year = date.getFullYear();
    },
    methods: {
        getData() {
            this.busy_loading = true;
            apiClient.get('/vue/users/absensestatistics', {
                params: this.filter,
            }).then((response) => {
                this.data = response.data;
            }).finally(() => {
                this.busy_loading = false;
            });
        },
        calcReportedTime(period) {
            let hours = 0;
            this.cause_codes.forEach((causeCode) => {
                hours += period[causeCode.id];
            });
            return period.worked_hours + hours;
        },
        holidayDeductionLabel(period) {
            const days = period.holiday_days;
            return `${days} ${days === 1 ? 'helgdag avdragen' : 'helgdagar avdragna'} (−${this.formatHours(period.holiday_hours)} t)`;
        },
        workhoursReason(day) {
            const reasons = {
                holiday: 'Exkluderad helgdag',
                holiday_included: 'Helgdag ingår enligt inställning',
                weekend: 'Helg utan schema',
                fallback: 'Standard: 8 t utan schema',
                no_hours: 'Schema utan timmar',
                scheduled: day.source === 'default' ? 'Veckotid / 5 × sysselsättningsgrad' : 'Arbetsschema',
            };
            return reasons[day.reason] || day.reason;
        },
        formatHours(hours) {
            return new Intl.NumberFormat('sv-SE', { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(hours || 0);
        },
        formatMinutesAsHours(minutes) {
            return this.formatHours((minutes || 0) / 60);
        },
        calcReportedTimeDiff(period) {
            if (period.expected_hours) {
                return new Intl.NumberFormat('sv-SE', { maximumFractionDigits: 2, minimumFractionDigits: 2, signDisplay: 'exceptZero' }).format(this.calcReportedTime(period) - period.expected_hours);
            }
            return '-';
        },
        calcAbsenseHours(period) {
            let hours = 0;
            this.cause_codes.filter((causeCode) => !this.excl_causecode.includes(causeCode.id)).forEach((causeCode) => {
                hours += period[causeCode.id];
            });
            return hours;
        },
        calcAbsensePercent(period) {
            if (this.calc === 'reported' && period.worked_hours) {
                return new Intl.NumberFormat('sv-SE', { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format((this.calcAbsenseHours(period) / (period.worked_hours + this.calcAbsenseHours(period))) * 100) + ' %';
            }
            if (this.calc === 'expected' && period.expected_hours) {
                return new Intl.NumberFormat('sv-SE', { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format((this.calcAbsenseHours(period) / period.expected_hours) * 100) + ' %';
            }
            return '-';
        },
        filterUsers(users) {
            if (!this.user.permissions.includes('red_edit_all_users')) {
                return users.filter((user) => this.user.stores.includes(user.store_id));
            }
            return users;
        },
    },
    computed: {
        ...mapState(useAuthStore, ['user']),
        select_years() {
            const arr = [];
            const date = new Date();
            const year = date.getFullYear();
            // eslint-disable-next-line no-plusplus
            for (let i = 0; i < 10; i++) {
                arr.push({
                    id: year - i,
                    label: year - i,
                });
            }
            return arr;
        },
    },
};

</script>
